import e from "react";
import a from "prop-types";
import { C as u } from "./Checkbox-Ce_NNaHa.es.js";
import { I as h } from "./InputError-DUbaPOaP.es.js";
import { T as k } from "./index-Dd-4N6BE.es.js";
import { L as p } from "./utils-Ci4OZEP4.es.js";
import './CheckboxGroup.css';const x = "CheckboxGroup-module__checkboxGroup___1obq3", _ = "CheckboxGroup-module__checkbox___mzr-T", n = {
  checkboxGroup: x,
  checkbox: _
}, i = ({ id: o, children: m, error: r, label: t, ariaLabelledBy: b }) => {
  const c = r ? `${o}-error-message` : null, d = e.Children.toArray(m), s = `label-for-${o}`;
  return /* @__PURE__ */ e.createElement("div", null, t && /* @__PURE__ */ e.createElement(k.Body, { tagName: "label", id: s, responsive: !0 }, t), /* @__PURE__ */ e.createElement(
    "fieldset",
    {
      className: n.checkboxGroup,
      "aria-labelledby": b || s,
      "aria-describedby": c,
      "aria-invalid": !!r,
      id: o
    },
    d.map((l) => /* @__PURE__ */ e.createElement(
      "div",
      {
        key: l.props.label || l.props.ariaLabelledBy,
        className: n.checkbox
      },
      /* @__PURE__ */ e.createElement(u, { ...l.props, error: !!r })
    ))
  ), r && /* @__PURE__ */ e.createElement(h, { id: c }, r));
};
i.propTypes = {
  /** Unique html id */
  id: a.string.isRequired,
  /** Checkbox components */
  children: a.node.isRequired,
  /** text to be displayed in an error message */
  error: a.string,
  /** text to be displayed for the label
   *
   * required if `ariaLabelledBy` is not defined
   */
  label: p,
  /** html id of alternate label
   *
   * required if `label` is not defined
   */
  ariaLabelledBy: p
};
i.defaultProps = {
  error: null,
  label: null,
  ariaLabelledBy: null
};
export {
  i as C
};
